import { Component, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { AuthenticationService } from 'src/core/services/authentication.service';
import { RefreshTokenService } from 'src/core/services/refresh-token.service';
import { SpinnerService } from 'src/core/services/spinner.service';
import { SentryService } from 'src/core/services/sentry.service';
import images from '../../../assets/json/full_data.json';
import { RightsHolder } from 'src/core/Models/interfaces.model';
import Jsona from 'jsona';
import { OrganizationService } from 'src/core/services/organization.service';
const dataFormatter = new Jsona();
import { AppConfig } from '../../app.config';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { OrganizationId } from 'src/core/helpers/organizationId-helper';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
})
export class LoginComponent {
  organizationPrefix: string = 'dk';
  email!: string;
  codeDelivered = false;
  pinCode = '';
  pinCodeLength = 4;
  wrongCode = false;
  counter = 0;
  otpValidityInSeconds = 0;
  image: any;
  wrongCodeCounter = 0;
  returnUrl!: string;

  fullName = '';
  userRole!: string;
  boardId!: string;

  activeAcceptanceTerms: any = {};
  activeCookieTerms: any = {};
  showAcceptanceTermsModal: boolean = false;
  showAcceptanceCookieModal: boolean = false;
  htmlContent: string = ``;
  cookieHtmlContent: string = ``;
  enableSentry: boolean = AppConfig.settings.enableSentry;
  safeHtmlContent: SafeHtml | undefined;

  constructor(
    private authenticationService: AuthenticationService,
    private messageService: MessageService,
    private spinnerService: SpinnerService,
    private refreshTokenService: RefreshTokenService,
    private route: ActivatedRoute,
    private router: Router,
    private sanitizer: DomSanitizer,
    private sentryService: SentryService,
    private organizationService: OrganizationService
  ) {
    //this.logout();
  }

  logout() {
    // remove user from local storage to log user out
    localStorage.clear();
    this.authenticationService.loggedIn.next(false);
  }

  ngOnInit() {
    this.organizationPrefix = sessionStorage.getItem('organisation') || 'dk';
    this.image = images[(Math.random() * images.length) | 0];
    //this.image = images[40];
    // get return url from route parameters or default to '/'
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';

    if (this.route.snapshot.queryParams['email']) {
      this.codeDelivered = true;
      this.email = this.route.snapshot.queryParams['email'];
      this.fullName = this.route.snapshot.queryParams['fullName'];
      this.userRole = this.route.snapshot.queryParams['Role'];
      this.boardId = this.route.snapshot.queryParams['boardId'];
      this.sendOTPCode();
    }

    // check if there is a logged in user with valid otp
    if (localStorage.getItem('currentUser')) {
      let currentUser = JSON.parse(localStorage.getItem('currentUser')!);
      if (currentUser.authenticated && currentUser.authenticated.access_token) {
        // navigate to reports
        this.router.navigate([this.returnUrl + '/reports']).then(() => {});
      }
    }
  }

  sendOTPCode() {
    // API Call -- Send code to email
    //this.spinnerService.show();
    this.authenticationService
      .sendOTP(this.email, this.organizationPrefix)
      .subscribe(
        (response: any) => {
          this.otpValidityInSeconds = 900;
          this.counter = 60;
          this.codeDelivered = true;
          this.codeCounter();
          this.messageService.add({
            severity: 'success',
            summary: 'Email Sent',
            detail:
              'An email has been sent to your email address. Please check your inbox.',
            life: 3000,
          });
          //this.spinnerService.hide();
        },
        (error) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail:
              'An error occurred while sending the code. Please try again.',
            life: 3000,
          });
          //this.spinnerService.hide();
        }
      );
  }

  validateOTP() {
    if (this.pinCode.length < 4) return;
    // API Call -- Verify code
    //this.spinnerService.show();
    this.authenticationService
      .validateOTP(this.email, this.organizationPrefix, this.pinCode)
      .subscribe(
        (response: any) => {
          this.messageService.add({
            severity: 'success',
            summary: 'Login verified',
            detail: 'You have been successfully logged in.',
            life: 3000,
          });
          this.getBoardPermissions(response);
          //this.spinnerService.hide();
        },
        (error) => {
          //this.spinnerService.hide();
          this.wrongCode = true;
          this.pinCode = '';
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'The code you entered is incorrect. Please try again.',
            life: 3000,
          });
        }
      );
  }

  addUserToBoard(userId: string, accessToken: string) {
    return this.authenticationService.addUserToBoard(
      this.boardId,
      userId,
      this.email,
      this.fullName,
      this.userRole,
      accessToken
    );
  }

  getBoardPermissions(response: any) {
    this.authenticationService
      .getCurrentBoardPermissions(
        response.currentUser.authenticated.access_token
      )
      .subscribe((currentBoardsPermissions: any) => {
        let currentUser = {
          ...response.currentUser,
          boardPermissions: currentBoardsPermissions,
          rightsHolder: null,
        };

        if (this.route.snapshot.queryParams['email']) {
          this.authenticationService
            .getCurrentBoard(
              this.boardId,
              currentUser.authenticated.access_token
            )
            .subscribe((currentBoard: any) => {
              currentUser = {
                ...currentUser,
                board: currentBoard,
              };


              this.authenticationService
                .getCurrentRightsHolderbyBoardId(
                  currentUser.board.id,
                  currentUser.authenticated.access_token
                )
                .subscribe((currentRightsHolder: RightsHolder) => {
                  currentUser = {
                    ...currentUser,
                    rightsHolder: currentRightsHolder,
                  };

                  this.initializeAgentMode();

                  // Save ONCE — fully populated
                  localStorage.setItem('currentUser', JSON.stringify(currentUser));
                  this.organizationService.setOrganizationIdInStorage(currentUser);
                  this.authenticationService.setLoggedIn(true);
                  this.spinnerService.hide();
                  this.refreshTokenService.setApiInterval();

                  // Navigate only after everything is saved
                  this.router.navigate([this.returnUrl + '/reports']).then(() => {});
                });
            });
        } else {
          // SetRightsHolder
          this.authenticationService
            .getCurrentRightsHolderbyBoardId(
              currentUser.board.id,
              currentUser.authenticated.access_token
            )
            .subscribe((currentRightsHolder: RightsHolder) => {
              currentUser = {
                ...currentUser,
                rightsHolder: currentRightsHolder,
              };

              // Save ONCE — fully populated
              localStorage.setItem('currentUser', JSON.stringify(currentUser));
              localStorage.setItem(
                'organizationId',
                String(
                  currentUser?.board?.organisationId
                    ? OrganizationId[
                        currentUser?.board
                          ?.organisationId as keyof typeof OrganizationId
                      ] ?? 1
                    : 2
                )
              );

              const isUserLabelAgent = this.checkIfUserIsLabelAgent();
              this.organizationService.setOrganizationIdInStorage(currentUser);
              this.initializeAgentMode();

              if (isUserLabelAgent) {
                const currentOrganization = sessionStorage.getItem('organisation') || 'dk';
                this.router
                  .navigate([this.returnUrl + '/maintenance'], {
                    state: { currentOrganization: currentOrganization },
                  })
                  .then(() => {});
                return;
              }

              if (currentUser.userAcceptanceTermsDetails?.isUserAcceptanceTermsAccepted) {
                if (
                  !currentUser.userCookiesDetails.isUserCookiesAccepted &&
                  !currentUser.userCookiesDetails.isCookiesRejectedByUser
                ) {
                  this.getActiveCookieTerms();
                } else {
                  if (currentUser.userCookiesDetails.isUserCookiesAccepted) {
                    this.initializeSentry(this.enableSentry);
                  }
                  this.authenticationService.setLoggedIn(true);
                  this.spinnerService.hide();
                  this.refreshTokenService.setApiInterval();
                  this.navigateToReports();
                }
              } else {
                let organisationId =
                  this.organizationPrefix == 'dk'
                    ? '2195ed89-bd12-4e27-9bdf-d8fcd9b8f14d'
                    : 'b8f77630-9666-4627-b234-f4a1b5329e17';
                this.authenticationService
                  .getActiveAcceptanceService(organisationId)
                  .subscribe((response: any) => {
                    this.activeAcceptanceTerms = response;
                    this.htmlContent = response.text
                      .replace(/\r\n/g, '')
                      .replace(/\\"/g, '');
                    this.showAcceptanceTermsModal = true;
                  });
              }
            });
        }
      });
  }

  checkIfUserIsLabelAgent() {
    const currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');

    if (currentUser.user.roleName === 'Label Agent') {
      return true;
    }
    return false;
  }

  private initializeAgentMode(): void {
    this.authenticationService.initializeAgentMode();
  }

  codeCounter() {
    let intervalId = setInterval(() => {
      this.counter--;
      if (this.counter === 0) {
        this.counter = this.otpValidityInSeconds;
        clearInterval(intervalId);
      }
    }, 1000);
  }

  goBack() {
    this.counter = 0;
    this.wrongCode = false;
    this.codeDelivered = false;
  }

  submitAcceptanceTerms() {
    let userId = JSON.parse(localStorage.getItem('currentUser')!).user.id;
    let activeAcceptanceTermsId = Number(this.activeAcceptanceTerms.id);
    this.authenticationService
      .acceptUserTerms(userId, activeAcceptanceTermsId)
      .subscribe((response: any) => {
        this.getActiveCookieTerms();
      });
  }

  getActiveCookieTerms() {
    let organisationId =
      this.organizationPrefix == 'dk'
        ? '2195ed89-bd12-4e27-9bdf-d8fcd9b8f14d'
        : 'b8f77630-9666-4627-b234-f4a1b5329e17';
    this.authenticationService
      .getActiveCookieTermsService(organisationId)
      .subscribe((response: any) => {
        this.showAcceptanceTermsModal = false;
        this.activeCookieTerms = response;
        this.cookieHtmlContent = response.text;
        this.showAcceptanceCookieModal = true;
      });
  }
  submitAcceptanceCookies() {
    console.debug('submitAcceptanceCookies');
    let userId = JSON.parse(localStorage.getItem('currentUser')!).user.id;
    let activeAcceptanceCookieId = Number(this.activeCookieTerms.id);
    this.authenticationService
      .acceptUserCookie(userId, activeAcceptanceCookieId, true)
      .subscribe((response: any) => {
        // update local storage with user cookies details
        let currentUser = JSON.parse(localStorage.getItem('currentUser')!);
        currentUser.userCookiesDetails = {
          activeCookiesId: activeAcceptanceCookieId,
          isUserCookiesAccepted: true,
          IsCookiesRejectedByUser: false,
        };
        localStorage.setItem('currentUser', JSON.stringify(currentUser));
        this.initializeAgentMode();
        // Initialize Sentry using the SentryService if cookies are accepted and Sentry is enabled
        if (this.enableSentry) {
          this.sentryService.initializeSentry();

          // Set user information for better tracking
          this.sentryService.setUser({
            id: currentUser.user.id,
            email: currentUser.user.email,
            username: `${currentUser.user.firstName} ${currentUser.user.lastName}`,
            board: `${currentUser.board.title}`
          });
        }

        this.navigateToReports();
      });
  }

  declineAcceptanceCookies() {
    let userId = JSON.parse(localStorage.getItem('currentUser')!).user.id;
    let activeAcceptanceCookieId = Number(this.activeCookieTerms.id);
    this.authenticationService
      .acceptUserCookie(userId, activeAcceptanceCookieId, false)
      .subscribe((response: any) => {
        // update local storage with user cookies details
        let currentUser = JSON.parse(localStorage.getItem('currentUser')!);
        currentUser.userCookiesDetails = {
          activeCookiesId: activeAcceptanceCookieId,
          isUserCookiesAccepted: false,
          IsCookiesRejectedByUser: true,
        };
        localStorage.setItem('currentUser', JSON.stringify(currentUser));
        this.initializeAgentMode();
        this.navigateToReports();
      });
  }

  navigateToReports() {
    this.authenticationService.setLoggedIn(true);
    // Set the interval time in milliseconds (e.g., 5000 milliseconds for 5 seconds)
    // Start the API calls using the service
    this.refreshTokenService.setApiInterval();
    this.router.navigate([this.returnUrl + '/reports']).then(() => {});
  }

  cancelAcceptanceTerms() {
    this.logout();
    this.showAcceptanceTermsModal = false;
    this.goBack();
  }

  cleanHtml(html: string): SafeHtml {
    // Replace escaped quotes and remove escaped line breaks/tabs
    const cleaned = html
      .replace(/\\"/g, '"') // Replace escaped double quotes
      .replace(/\\r\\n/g, '') // Remove carriage returns
      .replace(/\\t/g, '') // Remove tabs
      .replace(/&nbsp;/g, ' '); // Optional: decode &nbsp;

    return this.sanitizer.bypassSecurityTrustHtml(cleaned);
  }
  initializeSentry(enableSentry: boolean) {
    if (enableSentry && !this.sentryService.isSentryInitialized()) {
      this.sentryService.initializeSentry();

      const currentUser = JSON.parse(localStorage.getItem('currentUser')!);
      if (currentUser && currentUser.user) {
        this.sentryService.setUser({
          id: currentUser.user.id,
          email: currentUser.user.email,
          username: `${currentUser.user.firstName} ${currentUser.user.lastName}`,
          board: `${currentUser.board.title}`
        });
      }
    }
  }
}
